<script lang="ts">
defineComponent({
  name: "FilterMain",
});
</script>
<script setup lang="ts" generic="T extends FilterParamsBase">
import FilterFormDropdown from "@/components/Filter/FormDropdown.vue";
import BaseDropdownCheckbox from "@/components/Base/Dropdown/Checkbox.vue";
import FilterButtons from "@/components/Filter/Buttons.vue";
import {
  FilterCategory,
  FilterComponent,
  FilterParamsBase,
} from "@/types/filter.types";
import { BaseButtonKindEnum } from "@/components/Base/Button";

const { t } = useI18n();
type GalleryNewFilterProps = {
  categories: FilterCategory[];
  currentParams: T;
  hasQuery: boolean;
  defaultProps?: string[];
};

const props = defineProps<GalleryNewFilterProps>();

const emit = defineEmits([
  "update:modelValue",
  "reset",
  "submit",
  "toggleMobileFilter",
]);

const handleFilterChange = (label: string, value: T[typeof label]) => {
  emit("update:modelValue", { label, value });
};

const handleResetFilter = () => emit("reset");

const getComponentFromString = (componentName: string): FilterComponent => {
  switch (componentName) {
    case "BaseFormDropdown":
      return FilterFormDropdown;
    case "DropdownCheckbox":
      return BaseDropdownCheckbox;
    case "FilterButtons":
      return FilterButtons;
    default:
      return FilterFormDropdown;
  }
};

const categoryHasOptions = (category: FilterCategory) =>
  category.props.options.some((option) => !!option.value);

const getHasSelectedValues = (category: FilterCategory) => {
  const selectedValues = (props.currentParams as Record<string, string[]>)[
    category.id
  ];
  return selectedValues && selectedValues.length > 0;
};

const filteredCategories = computed(() =>
  props.categories.filter(categoryHasOptions)
);
</script>

<template>
  <div
    class="filter-components-main d-flex flex-wrap flex-gap-2 mb-3 d-none d-sm-none d-md-flex"
  >
    <IconButton
      :kind="BaseButtonKindEnum.WHITE"
      icon-name="magic"
      type="button"
      icon-position="left"
      :disabled="!hasQuery"
      class="font-sm"
      button-class="btn-semi-rounded btn-shadow"
      :class="{ 'has-selection': hasQuery }"
      @click="handleResetFilter"
    >
      {{ t("global.all") }}
    </IconButton>
    <component
      :is="getComponentFromString(category.component)"
      v-for="category in filteredCategories"
      :key="category.id"
      v-bind="category.props"
      button-class="font-sm btn-semi-rounded btn-shadow"
      :kind="BaseButtonKindEnum.WHITE"
      :selected-values="
        (currentParams as Record<string, string[]>)[category.id]
      "
      :class="{ 'has-selection': getHasSelectedValues(category) }"
      @change="handleFilterChange(category.id, $event as T[string])"
    />
  </div>
</template>
